import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { 
  ArrowLeft, 
  Building2, 
  Mail, 
  Phone, 
  MapPin, 
  FileText, 
  CheckCircle,
  AlertCircle,
  Loader2,
  UserCheck
} from 'lucide-react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';
import SupplierModal from '../SupplierModal';

const FornecedorCadastroPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get('invite');
  
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [inviteData, setInviteData] = useState(null);
  const [isInvite, setIsInvite] = useState(false);

  // ✅ SIMPLIFICADO: Verificar se é um convite
  useEffect(() => {
    window.scrollTo(0, 0);
    
    if (inviteToken) {
      setIsInvite(true);
      // ✅ REMOVIDO: Verificação prévia desnecessária
      // A validação será feita na função acceptInvite
    }
  }, [inviteToken]);

  const handleSubmit = async (formData) => {
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      if (isInvite) {
        // ✅ SIMPLIFICADO: Aceitar convite
        const acceptInvite = httpsCallable(functions, 'acceptInvite');
        const result = await acceptInvite({ 
          token: inviteToken,
          supplierData: formData
        });
        
        setSuccess(true);
        setTimeout(() => {
          navigate('/app/login');
        }, 2000);
      } else {
        // ✅ SIMPLIFICADO: Cadastro independente
        const createSupplier = httpsCallable(functions, 'createSupplier');
        const result = await createSupplier({ 
          ...formData,
          tipo_cadastro: 'independente'
        });
        
        setSuccess(true);
        setTimeout(() => {
          navigate('/app/login');
        }, 2000);
      }
    } catch (err) {
      console.error('Erro ao processar cadastro:', err);
      setError(err.message || 'Erro ao processar cadastro. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-2">
              <Building2 className="h-8 w-8 text-blue-600" />
              <span className="text-xl font-bold text-gray-900">QualiManager</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 flex items-center justify-center space-x-3">
            <UserCheck className="h-6 w-6 text-blue-600" />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                {isInvite ? 'Aceitar Convite de Fornecedor' : 'Cadastrar Minha Empresa'}
              </h1>
              <p className="text-blue-700">
                {isInvite 
                  ? 'Complete seu cadastro para se tornar um fornecedor parceiro'
                  : 'Junte-se à nossa rede de fornecedores qualificados'
                }
              </p>
            </div>
          </div>
        </div>

        {/* Form Container */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 flex items-center space-x-3">
              <AlertCircle className="h-5 w-5 text-red-500" />
              <span className="text-red-700">{error}</span>
            </div>
          )}

          <SupplierModal
            isOpen={true}
            onClose={() => navigate('/')}
            onSubmit={handleSubmit}
            mode="invite"
            initialData={inviteData || {}}
            loading={loading}
            error={error}
            success={success}
          />
        </div>
      </div>
    </div>
  );
};

export default FornecedorCadastroPage;
